/**
 * Interface für PIWIK Config
 * (könnte man in eigene Datei auslagern, seh aber aktuell keine Notwendigkeit)
 */
import {environment} from '@environments/environment';


export interface IPiwikConfig {
  scriptSrc: string;
  trackUrl: string;
  trackingActivated: boolean;
  siteId: string;
  disclaimerCookie: {
    name: string;
    accepted: string;
    denied: string;
  };
}

/**
 * Allgemeine Config des Piwik-Services
 */
export const piwikConfig: IPiwikConfig = {
  scriptSrc: environment.piwik.baseUrl,
  trackUrl: environment.piwik.baseUrl + 'piwik.php',
  trackingActivated: Boolean(environment.piwik.activated),
  siteId: environment.piwik.siteId,
  disclaimerCookie: {
    name: 'cookie_consent',
    accepted: 'accepted',
    denied: 'denied'
  }
};
